import React, { useState } from 'react';
import nextArrow from '@/assets/arrowNext.png';
import { Link } from '@mui/material';

const DocumentsTab = () => {
 
  return (
    <div className="descrt-component">
      <div className="row">
        <div className="col-12">
          <p className="f-20 text-black mb-3">Documents</p>
          <div className="invst-info-form docs bg-transparent p-0" style={{ height: 'auto' }}>
          
            <div className="table-main">
              <table className="w-100">
              
                <tbody>
                  <tr>
                    <td>
                      <span className="f-13 semi-bold text-black">Foundation document</span>
                    </td>
                    <td>
                      <span className="f-13">20170710 Foundation document HAYK AS_Redacted.pdf</span>
                    </td>
                    <td>
                      <Link className='pink down-link'><i className="fa-solid fa-download"></i> DownLoad</Link>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className="f-13 semi-bold text-black">Statutes</span>
                    </td>
                    <td>
                      <span className="f-13">Articles of association 20.12 (1).pdf</span>
                    </td>
                    <td>
                      <Link className='pink down-link'><i className="fa-solid fa-download"></i> DownLoad</Link>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className="f-13 semi-bold text-black">Annual accounts / Evidence of bank deposits</span>
                    </td>
                    <td>
                      <span className="f-13">Articles of association 20.12 (1).pdf</span>
                    </td>
                    <td>
                      <Link className='pink down-link'><i className="fa-solid fa-download"></i> DownLoad</Link>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className="f-13 semi-bold text-black">Valuation</span>
                    </td>
                    <td>
                      <span className="f-13">Articles of association 20.12 (1).pdf</span>
                    </td>
                    <td>
                      <Link className='pink down-link'><i className="fa-solid fa-download"></i> DownLoad</Link>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className="f-13 semi-bold text-black">(Shareholder) agreement on co-sale obligation/right</span>
                    </td>
                    <td>
                      <span className="f-13">Articles of association 20.12 (1).pdf</span>
                    </td>
                    <td>
                      <Link className='pink down-link'><i className="fa-solid fa-download"></i> DownLoad</Link>
                    </td>
                  </tr>
                </tbody>{' '}
              </table>
            </div>
          </div>
          <h4 className='f-20 pt-4'>Additional documents</h4>
          <div className="table-main">
              <table className="w-100">
              
                <tbody>
                  <tr>
                    <td>
                      <span className="f-13 semi-bold text-black">Conversion of debt</span>
                    </td>
                    <td>
                      <span className="f-13">20170710 Foundation document HAYK AS_Redacted.pdf</span>
                    </td>
                    <td>
                      <Link className='pink down-link'><i className="fa-solid fa-download"></i> DownLoad</Link>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className="f-13 semi-bold text-black">Balance sheet January-April 2024</span>
                    </td>
                    <td>
                      <span className="f-13">Articles of association 20.12 (1).pdf</span>
                    </td>
                    <td>
                      <Link className='pink down-link'><i className="fa-solid fa-download"></i> DownLoad</Link>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span className="f-13 semi-bold text-black">Results report January-April 2024</span>
                    </td>
                    <td>
                      <span className="f-13">Articles of association 20.12 (1).pdf</span>
                    </td>
                    <td>
                      <Link className='pink down-link'><i className="fa-solid fa-download"></i> DownLoad</Link>
                    </td>
                  </tr>
             
                </tbody>{' '}
              </table>
            </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentsTab;
